import { FilterSection } from 'components/shared/filters/FilterSlideout';
import { createGroupTypeDropdown, REVIEW_STATUS_DROPDOWN } from 'constants/filterConfigs';
import { capitalize } from 'lib/util';
import GroupType from 'models/GroupType';
import Profile from 'models/Profile';
import { ReviewStatus } from 'models/Review';
import { GroupAccessMode } from 'services/api/group';

export const ADMISSION_STATUS_FILTER_OPTIONS = Object.values(ReviewStatus)
  .filter((status) => status !== ReviewStatus.CANCELED)
  .map((status) => ({
    id: status,
    name: status === ReviewStatus.REJECTED ? 'Denied' : capitalize(status),
  }));

export function getFilterSections(
  snfGroupType: GroupType | undefined,
  profile: Profile,
  { showGroupFilter = true }: { showGroupFilter?: boolean } = {}
): FilterSection[] {
  const filters = [
    ...(showGroupFilter && snfGroupType
      ? [
          {
            ...createGroupTypeDropdown(snfGroupType, {
              clientId: profile.actingClient.id,
              accessModes: [GroupAccessMode.Allowed],
            }),
            name: 'group_id',
          },
        ]
      : []),
    { ...REVIEW_STATUS_DROPDOWN, options: ADMISSION_STATUS_FILTER_OPTIONS },
  ];

  return [{ title: 'Filters', filters }];
}
